import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase 설정 - Vite 환경변수 사용
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBN86RrV9R7znWSVp-6YDQHpCdQ6bPER5M",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "lightivewebsite.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "lightivewebsite",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "lightivewebsite.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "339133643857",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:339133643857:web:33d5eda8f440624b7c0c70",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-JH8B5XYPFQ"
};

// Firebase 앱 초기화 (중복 초기화 방지)
export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Firestore 인스턴스
export const db = getFirestore(app);

// Storage 인스턴스
export const storage = getStorage(app);

// Auth 인스턴스
export const auth = getAuth(app);

// Functions 인스턴스 (asia-northeast3 리전)
export const functions = getFunctions(app, 'asia-northeast3');

// 에뮬레이터 연결 (개발 환경에서만)
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('🔥 Firebase 에뮬레이터에 연결됨');
}
